import type { FC } from 'react';
import type { StepperSetupStep } from '@/stepper';
import { StepperSetupStepKey } from '@/stepper';
import { useStepperOnboarding } from '../../../../context/StepperOnboardingContext';
import StepperGreetingStepContent from '../StepperGreetingStepContent';
import StepperTestCallStepContent from '../StepperTestCallStepContent';
import StepperTransfersStepContent from '../StepperTransfersStepContent';
import StepperWebsiteStepContent from '../StepperWebsiteStepContent';

interface StepperSetupStepContentProps {
	isLocked?: boolean;
	step: StepperSetupStep;
}

const StepperSetupStepContent: FC<StepperSetupStepContentProps> = ({
	isLocked = false,
	step
}) => {
	const {
		submitOnboarding,
		goToNextStep,
		isCustomerCreatePending,
		isTrainingPending,
		goToNextStepFromWebsite
	} = useStepperOnboarding();

	switch (step.key) {
		case StepperSetupStepKey.ExtractWebsiteContent:
			return (
				<StepperWebsiteStepContent
					isLocked={isLocked}
					isTrainingPending={isTrainingPending}
					onTrain={goToNextStepFromWebsite}
				/>
			);

		case StepperSetupStepKey.CustomizeGreeting:
			return (
				<StepperGreetingStepContent
					isLocked={isLocked}
					onNext={goToNextStep}
				/>
			);

		case StepperSetupStepKey.CallSummariesTransfers:
			return (
				<StepperTransfersStepContent
					isLocked={isLocked}
					isPending={isCustomerCreatePending}
					onNext={submitOnboarding}
				/>
			);

		case StepperSetupStepKey.MakeTestCall:
			return <StepperTestCallStepContent />;

		default:
			return null;
	}
};

export default StepperSetupStepContent;
